<template>  <modal 
    :show.sync="isVisible" 
    class="branch-modal" 
    size="xl"
    :key="branch ? branch._id : 'new'"
  >
    <h6 slot="header" class="modal-title d-flex align-items-center">
      <i class="ni ni-building mr-2 text-primary"></i>
      {{ branch && branch._id ? 'Edit Branch' : 'Add New Branch' }}
    </h6>
    
    <template>
      <form @submit.prevent="save" class="branch-form">
        <!-- Main Branch Toggle -->
        <div class="form-group">
          <div class="custom-control custom-switch">
            <input 
              id="is-main-branch"
              class="custom-control-input" 
              v-model="newBranch.is_main"
              type="checkbox"
            />
            <label class="custom-control-label" for="is-main-branch">
              <span class="font-weight-600">Set as Main Branch</span>
            </label>
          </div>
          <small class="text-muted mt-1 d-block" v-if="newBranch.is_main">
            <i class="fa fa-info-circle mr-1"></i>
            This will become the primary location for this business
          </small>
        </div>

        <hr class="my-4">

        <!-- Basic Information -->
        <div class="form-section">
          <h6 class="section-title mb-3">
            <i class="ni ni-single-02 text-primary mr-2"></i>
            Basic Information
          </h6>
            <div class="row">
            <div class="col-md-4">
              <base-input
                v-model="newBranch.name"
                label="Branch Name (English)"
                placeholder="Enter branch name"
                required
              >
                <template slot="prepend">
                  <span class="input-group-text">
                    <i class="ni ni-building"></i>
                  </span>
                </template>
              </base-input>
            </div>
            
            <div class="col-md-4">
              <base-input
                v-model="newBranch.name_ar"
                label="Branch Name (Arabic)"
                placeholder="اسم الفرع"
              >
                <template slot="prepend">
                  <span class="input-group-text">
                    <i class="ni ni-world-2"></i>
                  </span>
                </template>
              </base-input>
            </div>
            
            <div class="col-md-4">
              <base-input
                v-model="newBranch.phone"
                label="Phone Number"
                placeholder="Enter phone number"
                type="tel"
              >
                <template slot="prepend">
                  <span class="input-group-text">
                    <i class="ni ni-mobile-button"></i>
                  </span>
                </template>
              </base-input>
            </div>
          </div>
        </div>

        <hr class="my-4">

        <!-- Location Details -->
        <div class="form-section">
          <h6 class="section-title mb-3">
            <i class="ni ni-pin-3 text-success mr-2"></i>
            Location Details
          </h6>          <div class="row">
            <div class="col-md-6">
              <base-input
                v-model="newBranch.city"
                label="City (English)"
                placeholder="Enter city name"
              >
                <template slot="prepend">
                  <span class="input-group-text">
                    <i class="ni ni-building"></i>
                  </span>
                </template>
              </base-input>
            </div>
            
            <div class="col-md-6">
              <base-input
                v-model="newBranch.city_ar"
                label="City (Arabic)"
                placeholder="اسم المدينة"
              >
                <template slot="prepend">
                  <span class="input-group-text">
                    <i class="ni ni-world-2"></i>
                  </span>
                </template>
              </base-input>
            </div>
          </div>            <div class="row">
            <div class="col-lg-12 mb-2">
              <label class="form-control-label">Address Search</label>
              <div class="input-group">
                <input
                  v-model="addressSearchQuery"
                  type="text"
                  class="form-control"
                  placeholder="Enter address to search for GPS coordinates"
                  @keyup.enter="searchAddress"
                  @input="clearLocationData"
                />
                <div class="input-group-append">
                  <button 
                    class="btn btn-primary" 
                    type="button" 
                    @click="searchAddress"
                    :disabled="!addressSearchQuery || searchingAddress"
                  >
                    <i class="fa fa-search mr-1" v-if="!searchingAddress"></i>
                    <i class="fa fa-spinner fa-spin mr-1" v-if="searchingAddress"></i>
                    {{ searchingAddress ? 'Searching...' : 'Search' }}
                  </button>
                </div>
              </div>
              <small class="text-muted">
                <i class="fa fa-info-circle mr-1"></i>
                Type an address and press Enter or click Search to get GPS coordinates
              </small>
            </div>
            <div class="col-lg-12">
              <base-input
                alternative=""
                label="GPS Link (Auto-generated)"
                placeholder="GPS link will be generated after address search"
                input-classes="form-control-alternative"
                v-model="newBranch.gpslink"
                readonly
              />
            </div>
          </div>
          
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-control-label">Address (English)</label>
                <textarea 
                  v-model="newBranch.address"
                  class="form-control"
                  rows="2"
                  placeholder="Enter full address"
                ></textarea>
              </div>
            </div>
            
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-control-label">Address (Arabic)</label>
                <textarea 
                  v-model="newBranch.address_ar"
                  class="form-control"
                  rows="2"
                  placeholder="العنوان الكامل"
                ></textarea>
              </div>
            </div>          </div>          
          <div class="alert alert-success mt-2" v-if="newBranch.location_lat && newBranch.location_long">
            <div class="row align-items-center">
              <div class="col-md-8">
                <i class="fa fa-check-circle mr-2"></i>
                <small><strong>Location Confirmed:</strong> GPS coordinates have been set automatically</small>
              </div>
              <div class="col-md-4 text-right">
                <a 
                  :href="newBranch.gpslink || ('https://www.google.com/maps/search/?api=1&query=' + newBranch.location_lat + ',' + newBranch.location_long)" 
                  target="_blank"
                  class="btn btn-sm btn-success"
                >
                  <i class="fa fa-external-link mr-1"></i> View on Map
                </a>
              </div>
            </div>
          </div>
          
          <div class="alert alert-info mt-2" v-else>
            <i class="fa fa-info-circle mr-2"></i>
            <small>Use the Google Maps search above to automatically set GPS coordinates for this branch</small>
          </div>
        </div>
        
        <hr class="my-4">
          <!-- Business Hours -->
        <div class="form-section">
          <h6 class="section-title mb-3">
            <i class="ni ni-time-alarm text-success mr-2"></i>
            Business Hours <small class="text-muted">(Optional)</small>
          </h6>
          
          <div v-if="!newBranch.business_hours || newBranch.business_hours.length === 0" class="no-hours-message">
            <div class="alert alert-light border">
              <div class="d-flex align-items-center">
                <i class="ni ni-calendar-grid-58 text-muted mr-3" style="font-size: 2rem;"></i>
                <div>
                  <h6 class="mb-1">No Business Hours Set</h6>
                  <p class="mb-2 text-muted">Add business hours to let customers know when this branch is open</p>                  <button type="button" @click="addBusinessHours" class="btn btn-sm btn-outline-success">
                    <i class="fa fa-plus mr-1"></i> Add Business Hours
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <div v-else class="hours-table-container">
            <div class="hours-table">
              <div class="hours-table-header">
                <div class="hours-day">Day</div>
                <div class="hours-time">Opening Time</div>
                <div class="hours-time">Closing Time</div>
                <div class="hours-actions">Actions</div>
              </div>
              
              <div v-for="(hours, index) in newBranch.business_hours" :key="'bh-'+index" class="hours-row">
                <div class="hours-day">
                  <select v-model="hours.day" class="form-control form-control-sm">
                    <option value="Monday">Monday</option>
                    <option value="Tuesday">Tuesday</option>
                    <option value="Wednesday">Wednesday</option>
                    <option value="Thursday">Thursday</option>
                    <option value="Friday">Friday</option>
                    <option value="Saturday">Saturday</option>
                    <option value="Sunday">Sunday</option>
                  </select>
                </div>
                <div class="hours-time">
                  <input type="time" v-model="hours.from" class="form-control form-control-sm">
                </div>
                <div class="hours-time">
                  <input type="time" v-model="hours.to" class="form-control form-control-sm">
                </div>
                <div class="hours-actions">
                  <button type="button" class="btn btn-sm btn-link text-danger" @click="removeBusinessHours(index)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
              <button type="button" @click="addBusinessHours" class="btn btn-sm btn-outline-success mt-2">
              <i class="fa fa-plus mr-1"></i> Add More
            </button>
            
            <!-- Apply to All Days Button for Business Hours -->
            <div class="hours-actions-row mt-2">
              <button 
                v-if="newBranch.business_hours && newBranch.business_hours.length > 0" 
                type="button" 
                class="btn btn-sm btn-outline-info" 
                @click="applyBusinessHoursToAll(newBranch.business_hours[newBranch.business_hours.length-1])"
              >
                <i class="fa fa-clone mr-1"></i> Apply Last Entry to All Days
              </button>
            </div>
          </div>
        </div>
        
        <hr class="my-4">
          <!-- Leisure/Break Hours -->
        <div class="form-section">
          <h6 class="section-title mb-3">
            <i class="ni ni-coffee-grain text-success mr-2"></i>
            Break Hours <small class="text-muted">(Optional)</small>
          </h6>
          
          <div v-if="!newBranch.leisure_hours || newBranch.leisure_hours.length === 0" class="no-hours-message">
            <div class="alert alert-light border">
              <div class="d-flex align-items-center">
                <i class="ni ni-coffee-grain text-muted mr-3" style="font-size: 2rem;"></i>
                <div>
                  <h6 class="mb-1">No Break Hours Set</h6>
                  <p class="mb-2 text-muted">Add break hours if this branch closes for lunch or prayer times</p>
                  <button type="button" @click="addLeisureHours" class="btn btn-sm btn-outline-success">
                    <i class="fa fa-plus mr-1"></i> Add Break Hours
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <div v-else class="hours-table-container">
            <div class="hours-table">
              <div class="hours-table-header">
                <div class="hours-day">Day</div>
                <div class="hours-time">From</div>
                <div class="hours-time">To</div>
                <div class="hours-actions">Actions</div>
              </div>
              
              <div v-for="(hours, index) in newBranch.leisure_hours" :key="'lh-'+index" class="hours-row">
                <div class="hours-day">
                  <select v-model="hours.day" class="form-control form-control-sm">
                    <option value="Monday">Monday</option>
                    <option value="Tuesday">Tuesday</option>
                    <option value="Wednesday">Wednesday</option>
                    <option value="Thursday">Thursday</option>
                    <option value="Friday">Friday</option>
                    <option value="Saturday">Saturday</option>
                    <option value="Sunday">Sunday</option>
                  </select>
                </div>
                <div class="hours-time">
                  <input type="time" v-model="hours.from" class="form-control form-control-sm">
                </div>
                <div class="hours-time">
                  <input type="time" v-model="hours.to" class="form-control form-control-sm">
                </div>
                <div class="hours-actions">
                  <button type="button" class="btn btn-sm btn-link text-danger" @click="removeLeisureHours(index)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
              <button type="button" @click="addLeisureHours" class="btn btn-sm btn-outline-success mt-2">
              <i class="fa fa-plus mr-1"></i> Add More
            </button>
            
            <!-- Apply to All Days Button for Leisure Hours -->
            <div class="hours-actions-row mt-2">
              <button 
                v-if="newBranch.leisure_hours && newBranch.leisure_hours.length > 0" 
                type="button" 
                class="btn btn-sm btn-outline-info" 
                @click="applyLeisureHoursToAll(newBranch.leisure_hours[newBranch.leisure_hours.length-1])"
              >
                <i class="fa fa-clone mr-1"></i> Apply Last Entry to All Days
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    
    <template slot="footer">
      <base-button type="secondary" @click="$emit('update:show', false)">
        <i class="fa fa-times mr-1"></i>
        Cancel
      </base-button>
      <base-button 
        type="primary" 
        @click="save"
        :loading="saving"
      >
        <i class="fa fa-save mr-1"></i>
        {{ branch && branch._id ? 'Update Branch' : 'Create Branch' }}
      </base-button>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import BaseInput from "@/components/BaseInput";
import BaseButton from "@/components/BaseButton";

export default {
  name: 'BranchModal',  components: {
    Modal,
    BaseInput,
    BaseButton
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    branch: {
      type: Object,
      default: null
    },
    saving: {
      type: Boolean,
      default: false
    }
  },  data() {
    return {
      address: "", // Store the Google Maps address data like the working implementation
      addressSearchQuery: "", // Address search input
      searchingAddress: false, // Loading state for address search
      newBranch: {
        name: '',
        name_ar: '',
        phone: '',
        address: '',
        address_ar: '',
        location_lat: '',
        location_long: '',
        gpslink: '',
        business_hours: [],
        leisure_hours: [],
        city: '',
        city_ar: '',
        is_main: false
      }
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.show;
      },
      set(value) {
        console.log("=== BRANCH MODAL isVisible SET ===");
        console.log("Setting isVisible to:", value);
        console.log("Current show prop:", this.show);
        this.$emit('update:show', value);
      }
    }
  },  watch: {
    show(val) {
      console.log("=== BRANCH MODAL SHOW CHANGED ===");
      console.log("New show value:", val);
      console.log("Branch prop:", this.branch);
      
      if (val && this.branch) {
        // When opening the modal with a branch, copy branch data
        console.log("Initializing form data with branch");
        this.initializeFormData();
      } else if (val) {
        // Reset form when opening modal without branch data
        console.log("Resetting form for new branch");
        this.resetForm();
      }        // Modal opened, initialize if needed
      if (val) {
        this.$nextTick(() => {
          console.log("Branch modal opened and ready");
        });
      }
    }
  },  mounted() {
    console.log("🔍 Branch Modal mounted");  },
  methods: {
    initializeFormData() {
      // Clone branch data to avoid direct modification of props
      this.newBranch = JSON.parse(JSON.stringify(this.branch));
      
      // Ensure business_hours and leisure_hours are arrays
      if (!this.newBranch.business_hours) this.newBranch.business_hours = [];
      if (!this.newBranch.leisure_hours) this.newBranch.leisure_hours = [];
      
      // Ensure gpslink exists
      if (!this.newBranch.gpslink) this.newBranch.gpslink = '';
      
      // Generate GPS link if coordinates exist but link doesn't
      if (this.newBranch.location_lat && this.newBranch.location_long && !this.newBranch.gpslink) {
        this.newBranch.gpslink = `https://www.google.com/maps/search/?api=1&query=${this.newBranch.location_lat},${this.newBranch.location_long}`;
      }
    },      resetForm() {
      this.addressSearchQuery = '';
      this.searchingAddress = false;
      this.newBranch = {
        name: '',
        name_ar: '',
        phone: '',
        address: '',
        address_ar: '',
        location_lat: '',
        location_long: '',
        gpslink: '',
        business_hours: [],
        leisure_hours: [],
        city: '',
        city_ar: '',
        is_main: false
      };    },
    
    searchAddress() {
      if (!this.addressSearchQuery.trim()) {
        return;
      }

      this.searchingAddress = true;
      
      // Check if Google Maps API is loaded
      if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
        console.error('Google Maps API not loaded');
        this.searchingAddress = false;
        this.$notify({
          type: 'error',
          title: 'Google Maps Error',
          text: 'Google Maps API is not loaded. Please refresh the page and try again.'
        });
        return;
      }

      // Use Google Geocoding API to get coordinates from address
      const geocoder = new google.maps.Geocoder();
      
      geocoder.geocode({ 
        address: this.addressSearchQuery 
      }, (results, status) => {
        this.searchingAddress = false;
        
        if (status === 'OK' && results && results.length > 0) {
          const result = results[0];
          const location = result.geometry.location;
          
          // Get latitude and longitude
          const lat = typeof location.lat === 'function' ? location.lat() : location.lat;
          const lng = typeof location.lng === 'function' ? location.lng() : location.lng;
          
          // Set GPS coordinates
          this.newBranch.location_lat = lat;
          this.newBranch.location_long = lng;
          
          // Generate GPS link
          this.newBranch.gpslink = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
          
          // Set formatted address
          this.newBranch.address = result.formatted_address;
          
          // Extract city information
          const addressComponents = result.address_components;
          for (let component of addressComponents) {
            if (component.types.includes('locality')) {
              this.newBranch.city = component.long_name;
              break;
            } else if (component.types.includes('administrative_area_level_1')) {
              this.newBranch.city = component.long_name;
            }
          }
          
          console.log('Address search successful:', {
            query: this.addressSearchQuery,
            formatted_address: result.formatted_address,
            coordinates: { lat, lng },
            city: this.newBranch.city
          });
          
          this.$notify({
            type: 'success',
            title: 'Address Found',
            text: `GPS coordinates set for: ${result.formatted_address}`
          });
          
        } else {
          console.error('Geocoding failed:', status);
          this.$notify({
            type: 'error',
            title: 'Address Not Found',
            text: 'Could not find GPS coordinates for the entered address. Please try a more specific address.'
          });
        }
      });
    },
    
    clearLocationData() {
      // Clear GPS data when user starts typing a new address
      this.newBranch.location_lat = '';
      this.newBranch.location_long = '';
      this.newBranch.gpslink = '';
    },
    
    save() {
      this.$emit('save', this.newBranch);
    },
    
    // Business Hours Methods
    addBusinessHours() {
      if (!this.newBranch.business_hours) {
        this.newBranch.business_hours = [];
      }
      
      this.newBranch.business_hours.push({
        day: 'Monday', // Default day
        from: '09:00', // Default opening time
        to: '17:00'    // Default closing time
      });
    },
    
    removeBusinessHours(index) {
      this.newBranch.business_hours.splice(index, 1);
    },
    
    applyBusinessHoursToAll(sourceHours) {
      const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
      // Clear existing hours
      this.newBranch.business_hours = [];
      
      // Create new hours for each day
      days.forEach(day => {
        this.newBranch.business_hours.push({
          day: day,
          from: sourceHours.from,
          to: sourceHours.to
        });
      });
      
      // Show success message
      this.$notify({
        type: 'success',
        title: 'Hours Applied',
        text: 'Business hours have been applied to all days'
      });
    },
    
    // Leisure Hours Methods
    addLeisureHours() {
      if (!this.newBranch.leisure_hours) {
        this.newBranch.leisure_hours = [];
      }
      
      this.newBranch.leisure_hours.push({
        day: 'Monday', // Default day
        from: '12:00', // Default break start time
        to: '13:00'    // Default break end time
      });
    },
    
    removeLeisureHours(index) {
      this.newBranch.leisure_hours.splice(index, 1);
    },
    
    applyLeisureHoursToAll(sourceHours) {
      const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
      // Clear existing hours
      this.newBranch.leisure_hours = [];
      
      // Create new hours for each day
      days.forEach(day => {
        this.newBranch.leisure_hours.push({
          day: day,
          from: sourceHours.from,
          to: sourceHours.to
        });
      });
      
      // Show success message
      this.$notify({
        type: 'success',
        title: 'Break Hours Applied',
        text: 'Break hours have been applied to all days'
      });
    },
    
    formatTimeTo12Hour(time24) {
      if (!time24) return '';
      
      // Parse the time in 24-hour format (HH:MM)
      const [hours24, minutes] = time24.split(':').map(Number);
      
      // Convert to 12-hour format
      const period = hours24 >= 12 ? 'PM' : 'AM';
      const hours12 = hours24 % 12 || 12; // Convert 0 to 12 for 12 AM
      
      // Format the result as "hh:mm AM/PM"
      return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
    },

    convertTo24Hour(time12) {
      if (!time12) return '';
      
      const [timePart, period] = time12.split(' ');
      let [hours, minutes] = timePart.split(':').map(Number);
      
      // Convert hours based on period (AM/PM)
      if (period === 'PM' && hours < 12) {
        hours += 12;
      } else if (period === 'AM' && hours === 12) {
        hours = 0;
      }
      
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }
  }
}
</script>

<style scoped>
.branch-modal .modal-dialog {
  max-width: 1200px;
  width: 95%;
}

.branch-modal .modal-content {
  max-height: 90vh;
  overflow-y: auto;
}

.branch-form {
  padding: 0;
}

.form-section {
  margin-bottom: 0;
}

/* Make form layout more compact */
.form-group {
  margin-bottom: 1rem;
}

hr.my-4 {
  margin: 1.5rem 0;
}

.section-title {
  color: #32325d;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 0.5rem;
}

.section-title i {
  font-size: 1rem;
}

.hours-table-container {
  margin-top: 15px;
}

.hours-table {
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  overflow: hidden;
}

.hours-table-header,
.hours-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  grid-gap: 10px;
  padding: 8px;
}

.hours-table-header {
  background-color: #f8f9fe;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #8898aa;
  border-bottom: 1px solid #e9ecef;
}

.hours-row {
  border-bottom: 1px solid #e9ecef;
}

.hours-row:last-child {
  border-bottom: none;
}

.hours-day,
.hours-time {
  display: flex;
  align-items: center;
}

.hours-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.hours-actions-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

.no-hours-message {
  margin-top: 15px;
}

/* Responsive adjustments */
@media (max-width: 1400px) {
  .branch-modal .modal-dialog {
    max-width: 1000px;
  }
}

@media (max-width: 1200px) {
  .branch-modal .modal-dialog {
    max-width: 900px;
  }
}

@media (max-width: 992px) {
  .branch-modal .modal-dialog {
    max-width: 90%;
  }
}
</style>
